<template>
  <div class="asset-detail-wrap">
    <div class="top-box clearfix">
      <p class="fl big-title">店铺详情</p>
      <el-button functional class="fr" :clstag="`pageclick|keycount|${pageClstag}|bind`" @click="isUnbindShow = true">解绑店铺</el-button>
    </div>
    <p class="item-title">基本信息</p>

    <div class="base-info">
      <p class="text"><label>店铺名称：</label><span>{{ assetInfo.assetName || '--' }}</span></p>
      <p class="text"><label>商家ID：</label><span>{{ assetInfo.businessId || '--' }}</span></p>
      <p class="text"><label>商家类型：</label><span>{{ assetInfo.businessType | formateBusinessType }}</span></p>
      <p class="text"><label>经营方式：</label><span>{{ assetInfo.assetType | formateAssetType(assetInfo.agentType) }}</span></p>
      <p class="text"><label>授权状态：</label><span>{{ assetInfo.grantStatus | formateGrantStatus }}</span></p>
      <p v-if="assetInfo.assetType === 2" class="text"><label>代运营期限：</label><span>{{ assetInfo.agentStartTime || '--' }} 至 {{ assetInfo.agentEndTime || '--' }}</span></p>
      <!-- <p class="text"><label>资产状态：</label><span>{{ assetInfo.assetStatus | formateStatus }}</span></p>
      <p class="text"><label>业务标识：</label><span>{{ assetInfo.businessId || '--' }}</span></p> -->
      <p class="text one-line"><label>企业名称：</label><span>{{ assetInfo.companyName }}</span></p>
    </div>

    <p class="item-title mt30">店铺账号信息</p>

    <!-- 查询 -->
    <el-form
      ref="searchForm"
      label-position="right"
      :inline="true"
      :model="searchForm"
      class="search-list"
    >
      <el-form-item
        label="店铺账号"
        label-width="82px"
        class="search-item"
      >
        <el-input
          v-model.trim="searchForm.assetAccount"
          placeholder="请输入"
          class="w238"
          clearable
        >
        </el-input>
      </el-form-item>

      <!-- <el-form-item
        label="店铺岗位"
        label-width="72px"
        class="search-item"
      >
        <el-select v-model="searchForm.job" class="w238" placeholder="全部">
          <el-option
            v-for="(item, index) in jobList"
            :key="index"
            :label="item.label"
            :value="item.value"
            clearable
          >
          </el-option>
        </el-select>
      </el-form-item> -->

      <!-- <el-form-item
        label="员工姓名"
        label-width="92px"
        class="search-item"
      >
        <el-input
          v-model.trim="searchForm.employeeName"
          placeholder="请输入"
          class="w238"
          clearable
        >
        </el-input>
      </el-form-item> -->

      <el-form-item >
        <el-button
          class="btn search-btn"
          functional
          :clstag="`pageclick|keycount|${pageClstag}|account_search`"
          @click="search"
        >
          查询
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 员工列表 -->
    <div class="list-box">
      <el-table
        v-loading="loading"
        :data="employeeList"
        tooltip-effect="dark"
        :resizable="false"
        class="employee-list"
        style="width: 100%"
      >
        <el-table-column label="店铺账号" prop="assetAccount"></el-table-column>
        <el-table-column label="账号状态" prop="assetAccountStatus">
          <template slot-scope="scope">
            <span :class="{red: scope.row.assetAccountStatus === 0}">{{ scope.row.assetAccountStatus | formateStatus }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column  label="资产岗位" prop="assetAccountRole"></el-table-column> -->
        <el-table-column label="员工姓名" prop="employeeName">
          <template slot-scope="scope">
            <span>{{ scope.row.employeeName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.employeeId"
              type="text"
              class="unbind-btn"
              :clstag="`pageclick|keycount|${pageClstag}|account_op_unbind`"
              @click="unbind(scope.row)"
            >
              解除分配
            </el-button>
            <el-button
              v-if="scope.row.employeeId"
              type="text"
              class="unbind-btn"
              :clstag="`pageclick|keycount|${pageClstag}|account_op_rebind`"
              @click="rebind(scope.row)"
            >
              重新分配
            </el-button>
            <el-button
              v-if="!scope.row.employeeId"
              type="text"
              class="bind-btn"
              :clstag="`pageclick|keycount|${pageClstag}|account_op_bind`"
              :disabled="scope.row.assetAccountStatus === 0"
              @click="bind(scope.row)"
            >
              分配
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <el-pagination
      :current-page="pageNum"
      :page-sizes="[10, 20]"
      :page-size="pageSize"
      class="page-box"
      layout="total, prev, pager, next, sizes, jumper"
      :total="total"
      @size-change="changePageSize"
      @current-change="changeCurrentPage"
    >
    </el-pagination>
    <el-button size="large" plain class="go-back-btn" @click="goBack">返回</el-button>

    <!-- 绑定弹窗 -->
    <BindEmployee
      v-if="isBind"
      :visible="isBind"
      :asset-info="assetInfo"
      :account-info="currentBindInfo"
      :is-re-bind="isReBind"
      @closeBind="closeBind"
    />

    <!-- 解绑弹窗 -->
    <UnbindShop
      v-if="isUnbindShow"
      :page-clstag="pageClstag"
      :visible="isUnbindShow"
      :current-select="assetInfo"
      @closeSure="closeUnbindSure"
    />
  </div>
</template>

<script>
import {
  assetInfo, assetAccountList, assetEmployeeUnset,
} from '@/api/apis/property';
import { clstagA } from '@/utils/index';
import BindEmployee from './components/bindEmployee.vue';
import UnbindShop from './components/unbindShop.vue';

export default {
  name: 'Detail',
  components: {
    BindEmployee,
    UnbindShop,
  },
  filters: {
    formateStatus(status) {
      const list = {
        0: '未启用',
        1: '已启用',
      };
      if (typeof status !== 'undefined') {
        return list[status];
      }
      return '--';
    },
    formateAssetType(assetType, agentType) {
      const list = {
        1: '直营',
        2: '代运营',
      };
      if (typeof assetType !== 'undefined') {
        let other = '';
        if (assetType === 2) {
          other = agentType === 0 ? '-部分代管' : '-整店代管';
        }
        return `${list[assetType]}${other}`;
      }
      return '--';
    },
    formateBusinessType(businessType) {
      const list = {
        110: '全渠道',
        200: 'POP',
        300: '供应商',
      };
      if (typeof businessType !== 'undefined') {
        return list[businessType];
      }
      return '--';
    },
    formateGrantStatus(grantStatus) {
      const list = {
        1: '待审核',
        3: '未授权 - 未通过',
        4: '已授权',
        5: '未授权 - 已过期',
        6: '未授权 - 已终止',
      };
      if (typeof grantStatus !== 'undefined') {
        return list[grantStatus];
      }
      return '--';
    },
    formateAuthStatus(authStatus, assetType) {
      // 直营为生效状态
      if (assetType === 1) {
        return '生效';
      }

      // 1：待处理，2：同意，3：拒绝，4：终止
      const list = {
        1: '待审核',
        2: '生效',
        3: '已驳回',
        4: '已到期',
      };
      if (typeof authStatus !== 'undefined') {
        return list[authStatus];
      }
      return '--';
    },
  },
  data() {
    return {
      assetInfo: {},
      searchForm: {
        assetAccount: '',
        job: null,
        employeeName: '',
      },
      jobList: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '店长',
          value: 1,
        },
        {
          label: '美工',
          value: 2,
        },
        {
          label: '运营',
          value: 3,
        },
        {
          label: '客服',
          value: 4,
        },
        {
          label: '售后',
          value: 5,
        },
        {
          label: '财务',
          value: 6,
        },
      ],
      employeeList: [],
      loading: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      params: {},
      isBind: false, // 绑定弹窗展示
      currentBindInfo: {}, // 当前绑定资产
      isReBind: false, // 是否是重新解绑
      isUnbindShow: false, // 解绑确认弹窗
    };
  },
  computed: {
    companyName() {
      return this.$store.state.companyName;
    },
    // 顶部解绑、解除代运营埋点
    pageClstag() {
      const page = 'property_detail';
      const { assetType, agentType } = this.assetInfo;
      if (assetType === 1) {
        return page;
      }
      return `${page}_agent${agentType}`;
    },
  },
  mounted() {
    this.assetInfo.assetId = this.$route.query.assetId || '';
    this.getAssetInfo();
  },
  methods: {
    // 返回列表
    goBack() {
      this.$router.push({ name: 'shopList' });
    },
    // 查询资产详情
    async getAssetInfo() {
      const res = await assetInfo({ assetId: this.assetInfo.assetId });
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.assetInfo = data;
        this.init();
      } else if (code === 4001) {
        this.$message.error(message || '资产信息不存在！');
        this.$router.push({ name: 'shopList' });
      } else {
        this.$message.error(message || '获取资产信息失败！');
      }
    },
    // 获取资产列表
    async getAssetAccountList(params) {
      this.loading = true;
      Object.keys(this.searchForm).forEach((item) => {
        if (this.searchForm[item]) {
          params[item] = this.searchForm[item];
        }
      });
      params.assetId = this.assetInfo.assetId;
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      const res = await assetAccountList(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      this.loading = false;
      if (code === 200) {
        this.employeeList = data.content || [];
        this.pageSize = Number(data.pageSize);
        this.pageNum = Number(data.pageNo);
        this.total = Number(data.totalNumber);
        this.loading = false;
      } else {
        this.$message.error(message || '获取资产员工失败！');
      }
    },
    // 重新分配
    rebind(item) {
      this.isReBind = true;
      this.bind(item);
    },
    // 解绑员工
    unbind(item) {
      const confirmText = ['确认解除账号员工分配关系吗？', `员工姓名：${item.employeeName}`, `店铺账号：${item.assetAccount}`];
      const newDatas = [];
      const h = this.$createElement;
      confirmText.forEach((text) => {
        newDatas.push(h('p', null, text));
      });
      this.$confirm(h('div', null, newDatas), '', {
        confirmButtonText: '解除分配',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          clstagA(`pageclick|keycount|${this.pageClstag}|account_op_unbind_sure`);
          const params = {
            assetAccount: item.assetAccount,
            assetId: this.assetInfo.assetId,
            employeeId: item.employeeId || 1,
          };
          const res = await assetEmployeeUnset(params);
          const {
            // eslint-disable-next-line no-unused-vars
            code, data, message, subErrors,
          } = res;
          if (code === 200) {
            this.$message({
              message: '解除分配成功！',
              type: 'success',
            });
            this.init(this.params.pageNum);
          } else {
            this.$message.error(message || '解绑失败请稍后重试！');
          }
        })
        .catch(() => {
          clstagA(`pageclick|keycount|${this.pageClstag}|account_op_unbind_cancel`);
        });
    },
    // 去绑定
    bind(item) {
      this.currentBindInfo = item;
      this.isBind = true;
    },
    // 关闭绑定弹窗
    closeBind(update) {
      this.isBind = false;
      this.isReBind = false;
      if (update) {
        this.init(this.params.pageNum);
      }
    },
    // 关闭解绑确认弹窗
    closeUnbindSure(update) {
      this.isUnbindShow = false;
      this.currentSelect = {};
      if (update) {
        this.$router.push({ name: 'shopList' });
        // TODO 确认代运营资产解除后，此条数据会被删除？
        // this.getAssetInfo();
        // this.init(this.params.pageNum);
      }
    },
    changePageSize(val) {
      this.loading = true;
      this.pageSize = val;
      this.pageNum = 1;
      this.params.pageSize = val;
      this.params.pageNum = 1;
      this.getAssetAccountList(this.params);
    },
    changeCurrentPage(val) {
      this.loading = true;
      this.pageNum = val;
      this.params.pageNum = val;
      this.getAssetAccountList(this.params);
    },
    // 查询
    search() {
      this.init();
    },
    // 初始化
    init(pageNum = 1) {
      // 待审核不查询店铺账号
      if (this.assetInfo.grantStatus === 1) {
        return;
      }
      this.pageNum = pageNum;
      const data = {
        pageNum,
        pageSize: this.pageSize,
      };
      this.params = data;
      this.getAssetAccountList(this.params);
    },
  },
};
</script>

<style lang="scss">
.asset-detail-wrap {
  padding: 30px 20px 106px;
  width: 100%;
  box-sizing: border-box;
  .top-box {
    width: 100%;
    line-height: 20px;

    .big-title {
      font-size: 18px;
      color: #333333;
      font-weight: 600;
    }

    .act-status {
      margin-left: 10px;
      padding: 0 7px;
      font-size: 12px;
      color: #454C5C;
      border: 1px solid #454C5C;
      border-radius: 2px;
      line-height: 18px;
      &.red {
        color: #FF3333;
        border-color: #FF3333;
      }
      &.orange {
        color: #FF9900;
        border-color: #FF9900;
      }
      &.green {
        color: #00BB66;
        border-color: #00BB66;
      }
    }
  }

  .item-title {
    margin: 20px 0 15px 10px;
    width: 100%;
    padding-left: 5px;
    font-size: 14px;
    color: #333333;
    font-weight: 500;
    line-height: 14px;
    border-left: 4px solid #4d80f0;
    box-sizing: border-box;
    &.mt30 {
      margin-top: 30px;
    }
  }

  .base-info {
    display: flex;
    width: 100%;
    padding: 0 10px;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 12px;
    box-sizing: border-box;
    flex-wrap: wrap;
    .text:last-child {
      margin-bottom: 0;
    }
    .text {
      width: 30%;
      margin-bottom: 10px;
      line-height: 12px;
      &.one-line {
        width: 100%;
      }
    }
    label {
      display: inline-block;
      width: 84px;
      text-align: right;
    }
  }
  .red {
    color: #FF3333;
  }

  .w238 {
    width: 238px;
  }

  .list-box {
    padding-top: 10px;
  }
  .employee-list {
    margin-bottom: 10px;
    width: 100%;
    background: #ffffff;
    border-bottom: none;
    font-size: 12px;
    color: #464c5b;
    line-height: 17px;
  }
  .page-box {
    margin-bottom: 30px;
    text-align: right;
  }
}
</style>
